import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  getWeekList () {
    return Vue.http.get(urls.MATCH_WEEK_URL, {'headers': authHeaders.getAuthHeaders()})
  },
  getWeekListForLeague (leagueId) {
    let target = urls.MATCH_WEEK_URL + '?league=' + leagueId
    return Vue.http.get(target, {'headers': authHeaders.getAuthHeaders()})
  },
  createWeek (week) {
    let body = JSON.stringify(week)
    return Vue.http.post(urls.MATCH_WEEK_URL, body, {'headers': authHeaders.getAuthHeaders()})
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/match-week.api.js